import React, { useEffect, useState } from "react";
import { useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";
import AuthContent from "widgets/Gift/AuthContent";
import NoAuthContent from "widgets/Gift/NoAuthContent";
import { GetGiftApi } from "./api";
import { useParams } from "react-router-dom";
import { useCookies } from "react-cookie";

const Gift: React.FC = () => {
  const { id } = useParams();
  const { auth_key, user_info } = useAppSelector(userSelect);
  const [cookies] = useCookies(["auth_key", "user_id"]);

  const [gift, setGift] = useState();

  const fetchGiftInfo = () => {
    GetGiftApi({ id: Number(id), user_id: user_info?.id }).then((res) =>
      setGift(res)
    );
  };

  useEffect(() => {
    if (cookies.auth_key) {
      user_info && fetchGiftInfo();
      return;
    }

    fetchGiftInfo();
  }, [cookies, user_info]);

  return (
    <main>
      {auth_key && <AuthContent fetchGiftInfo={fetchGiftInfo} gift={gift} />}
      {!auth_key && <NoAuthContent gift={gift} />}
    </main>
  );
};

export default Gift;
